import { Component, OnInit } from '@angular/core';
import { DriversService } from './drivers.service';
import { MethodOfPaymentService } from './method-of-payment.service';

@Component({
  selector: 'app-system-setup',
  templateUrl: './system-setup.component.html',
  styleUrls: ['./system-setup.component.css'],
  providers: [DriversService, MethodOfPaymentService]
})
export class SystemSetupComponent implements OnInit {

  constructor(
    public drivers: DriversService,
    public payment: MethodOfPaymentService
  ) { }

  ngOnInit() {
  }

}
